import http from '../../Common/api';
import { payerDomain } from '../../Common/constants';

import { aggregatorsUrl, payersUrl, dropDownDefault } from './constants';
import { normalizeAggregators, normalizePayers, normalizeTasks } from './normalizers';

const getAggregatorOptions = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return dropDownDefault;
  }
};

const getPayerOptions = async aggregatorID => {
  try {
    const payers = await http.get(`${payersUrl}${aggregatorID}/`);

    return normalizePayers(payers);
  } catch (error) {
    return [];
  }
};

const getTaskReports = async ({ aggregatorID, payerID }) => {
  try {
    const state = aggregatorID.slice(0, 2);
    const taskUrl = `${payerDomain}/tasks-for-aggregators/${state}/${payerID}/`;
    const response = await http.get(taskUrl);

    return { taskList: normalizeTasks(response.taskList), status: '' };
  } catch (error) {
    return { taskList: [], status: error.status };
  }
};

export { getAggregatorOptions, getPayerOptions, getTaskReports };
